/**
 * url处理相关函数
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/**
 * [formatUrl url格式化]
 * 合并重复参数和?，重复参数以,分割,按照先？后#格式格式化url
 * @param    {[string]}   url [待格式化的url字符串，默认是当前页面url地址]
 * @return   {[string]}       [格式化后的url字符串]
 */
import objectAssign from "object-assign";
export var formatUrl = function (url) {
    if (url === void 0) { url = window.location.href; }
    var curUrl = getUrl(url), hash = getHash(url), searchStr = getSearch({ url: url, dataType: "string" });
    return curUrl + searchStr + hash;
};
/**
 *[getPageName 获取页面名称即/和.html之前的部分]
 * @param    {[string]}   url [url字符串，默认是当前页面url地址]
 * @return   {[string]}       [页面名称]
 */
export var getPageName = function (url) {
    if (url === void 0) { url = window.location.href; }
    var urlStr = getUrl(url), t1 = urlStr.lastIndexOf("/") + 1, t2 = urlStr.lastIndexOf(".html");
    return urlStr.substring(t1, t2);
};
/**
 *[getUrl 获取除？及#以外的全域名地址]
 * @param    {[string]}   url [url字符串，默认是当前页面url地址]
 * @return   {[string]}       [除？及#以外的全域名地址]
 */
export var getUrl = function (url) {
    if (url === void 0) { url = window.location.href; }
    var t1 = url.indexOf("?") == -1 ? url.length : url.indexOf("?"), t2 = url.indexOf("#") == -1 ? url.length : url.indexOf("#"), t3 = t1 < t2 ? t1 : t2, urlStr = url.substring(0, t3);
    return urlStr;
};
/**
 *[getHash 获取url中的哈希值，及#后的值]
 * @param    {[string]}   url [url字符串，默认是当前页面url地址]
 * @return   {[string]}       [带#的哈希值]
 */
export var getHash = function (url) {
    if (url === void 0) { url = window.location.href; }
    // 获取url哈希值，如果url中包含# 则返回#哈希值，否则返回''
    var hashIndex = url.indexOf("#"), hashStr;
    if (hashIndex == -1) {
        return "";
    }
    else {
        hashStr = url.substring(hashIndex, url.length).split("?");
        return hashStr[0];
    }
};
export var getSearch = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.url, url = _c === void 0 ? window.location.href : _c, _d = _b.dataType, dataType = _d === void 0 ? "object" : _d, _e = _b.params, params = _e === void 0 ? {} : _e, _f = _b.blackList, blackList = _f === void 0 ? [] : _f;
    if (url.indexOf("?") != -1) {
        // 循环
        var w2 = url.indexOf("?", url.indexOf("?") + 1) == -1
            ? url.length
            : url.indexOf("?", url.indexOf("?") + 1), j1 = url.indexOf("#", url.indexOf("?") + 1) == -1
            ? url.length
            : url.indexOf("#", url.indexOf("?") + 1), end = w2 < j1 ? w2 : j1, curUrl = url.substring(url.indexOf("?"), end); // 获取url中"?"符后的字串
        url = url.substring(end);
        var paramsStr = curUrl.substr(1), paramsArray = paramsStr.split("&"), key = void 0, val = void 0;
        if (dataType.toLowerCase() == "string") {
            // 返回字符串
            if (typeof params == "undefined" || JSON.stringify(params) == "{}") {
                params = "?";
            }
            for (var i = 0; i < paramsArray.length; i++) {
                key = paramsArray[i].split("=")[0];
                val = paramsArray[i].split("=")[1];
                if (blackList.indexOf(key) == -1) {
                    // eslint-disable-next-line max-depth
                    if (!(params == "?" && i == 0)) {
                        params += "&";
                    }
                    params += key + "=" + val;
                }
            }
        }
        else {
            // 返回对象 重复key值的用数组存储
            if (typeof params == "undefined") {
                params = {};
            }
            for (var i = 0; i < paramsArray.length; i++) {
                key = paramsArray[i].split("=")[0];
                val = paramsArray[i].split("=")[1];
                // key不在这个黑名单里面的话就导出
                if (typeof params != "string" && blackList.indexOf(key) == -1) {
                    // eslint-disable-next-line max-depth
                    if (typeof params[key] != "undefined") {
                        var returnUrl = __spreadArray(__spreadArray([], __read(params[key])), __read(val));
                        params[key] = returnUrl;
                    }
                    else {
                        params[key] = val;
                    }
                }
            }
        }
        return getSearch({ url: url, dataType: dataType, params: params });
    }
    else {
        return params;
    }
};
/**
 * [getParam 获取url中指定参数]
 * @param    {object}   options.url   [默认为页面url,待处理的url地址]
            options.key   [待获取的参数值]
 * @return   {string}                 [key存在则返回对应的value值，若不存在则返回空字符串]
 */
// export const getParam = ({ url = window.location.href, key = '' } = {}) => {
// 	let params = getSearch({ url: url }),
// 		k, v = '';
// 	for (k in params) {
// 		if (k == key) {
// 			v = params[k];
// 			break;
// 		}
// 	}
// 	return v;
// }
/**
 * [removeParam 删除指定参数]
 * @param    {object}   options.url   [默认为页面url,待处理的url地址]
 *                      options.key   [待删除的key]
 *                      options.val   [当url中key等于val时,删除key;当typeof val=='undefined'时,表示只要有key值就删除]
 * @return   {[string]}                 [删除key之后的url]
 */
export var removeParam = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.url, url = _c === void 0 ? window.location.href : _c, _d = _b.key, key = _d === void 0 ? "" : _d, _e = _b.val, val = _e === void 0 ? "" : _e;
    if (typeof key == "undefined") {
        return url;
    }
    var curUrl = getUrl(url), hash = getHash(url), searchObj = getSearch({ url: url }), k, newSearchObj = {}, isVal = !!val;
    for (k in searchObj) {
        if (!((isVal && k == key && searchObj[k] == val) || (!isVal && k == key))) {
            newSearchObj[k] = searchObj[k];
        }
    }
    return curUrl + objToSearchStr(newSearchObj) + hash;
};
/**
 * [setUrlParam 设置url参数，可以一次设置多个]
 * @param    {object}   options.url    [默认为页面url,待处理的url地址]
 *                      options.params [对象，待添加的参数对象]
 *                      options.needEncode [boolean, 参数是否要经过decode]
 * @return   {string}                  [设置参数后的url字符串]
 */
export var setUrlParam = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.url, url = _c === void 0 ? window.location.href : _c, _d = _b.params, params = _d === void 0 ? {} : _d, _e = _b.needEncode, needEncode = _e === void 0 ? true : _e, _f = _b.blackList, blackList = _f === void 0 ? [] : _f, _g = _b.keyName, keyName = _g === void 0 ? 'name' : _g, _h = _b.valName, valName = _h === void 0 ? 'value' : _h;
    var curUrl = getUrl(url), hash = getHash(url), searchObj = typeof getSearch({ url: url }) == "undefined" ? {} : getSearch({ url: url, blackList: blackList });
    if (Object.prototype.toString.call(params) === '[object Object]' && Object.keys(params).length > 0) {
        var newSearchObj = objectAssign(searchObj, params);
        return curUrl + objToSearchStr(newSearchObj, needEncode) + hash;
    }
    else if (Object.prototype.toString.call(params) === '[object Array]' && params.length > 0) {
        var oldSearchArr = resolveObjToArr(searchObj);
        return curUrl + arrToSearchStr(__spreadArray(__spreadArray([], __read(params)), __read(oldSearchArr)), { keyName: keyName, valName: valName }) + hash;
    }
    else {
        return url;
    }
};
/**
 * [objToSearchStr 对象转化成?key=val&key2=val2格式的字符串]
 * @param    {object}   params [参数对象]
 * @return   {string}       [转化成?key=val&key2=val2格式的字符串]
 */
export var objToSearchStr = function (params, needEncode) {
    if (needEncode === void 0) { needEncode = true; }
    if (Object.keys(params).length == 0) {
        return "";
    }
    var searchStr = "?", i = 0;
    for (var key in params) {
        if (i != 0) {
            searchStr += "&";
        }
        i++;
        if (needEncode) {
            searchStr += key + "=" + encodeURIComponent(decodeURIComponent(params[key]));
        }
        else {
            searchStr += key + "=" + params[key];
        }
    }
    return searchStr;
};
/** 获取URL参数**/
export var getUrlParam = function (key, url) {
    if (url === void 0) { url = ""; }
    if (typeof window == "undefined") {
        return "";
    }
    url = url ? url : window.location.search;
    var paraString = url.substring(url.indexOf("?") + 1, url.length).split("&"), i, j, paraObj = {};
    for (i = 0; (j = paraString[i]); i++) {
        paraObj[j.substring(0, j.indexOf("=")).toLowerCase()] = j.substring(j.indexOf("=") + 1, j.length);
    }
    var returnValue = paraObj[key.toLowerCase()];
    if (typeof returnValue == "undefined") {
        return "";
    }
    else {
        return returnValue;
    }
};
/** 设置url中的参数**/
//   export const setUrlParam = (
// 	name: string,
// 	value: string,
// 	url = window.location.href.toString()
//   ) => {
// 	let newUrl = "",
// 	  reg = new RegExp("(^|)" + name + "=([^&]*)(|$)"),
// 	  tmp = name + "=" + value;
// 	if (url.match(reg) != null) {
// 	  //@ts-ignore
// 	  newUrl = url.replace(eval(reg), tmp);
// 	} else {
// 	  if (url.match("[?]")) {
// 		newUrl = url + "&" + tmp;
// 	  } else {
// 		newUrl = url + "?" + tmp;
// 	  }
// 	}
// 	return newUrl;
//   };
/**
 *
 * @param targetObj 必填，要解析的对象数据，{key: xxx}
 * @param opts
 *   keyName  可选 string 输出的对象数组中的 解析对象中的value对应的value名,默认name
 *   valueName 可选 string 输出的对象数组中的 解析对象中的value对应的key名 默认value
 * @returns 对象数组
 *
 * const obj = {sex: '男', age: 18, family:[{a: 1, b: 2}]}
 * const result = resolveObjToArr(obj, {whiteList: ['sex']})
 * // result = [{name: 'age', value: 18}, {name: 'family', value: [{a: 1, b: 2}]}]
 */
export var resolveObjToArr = function (targetObj, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.keyName, keyName = _c === void 0 ? 'name' : _c, _d = _b.valName, valName = _d === void 0 ? 'value' : _d;
    var resultArr = [];
    if (Object.prototype.toString.call(targetObj) === '[object Object]') {
        var _loop_1 = function (key) {
            var _e;
            if (Object.prototype.toString.call(targetObj[key]) === '[object Array]') {
                // eslint-disable-next-line no-loop-func
                targetObj[key].map(function (item) {
                    var _a;
                    resultArr = __spreadArray(__spreadArray([], __read(resultArr)), [
                        (_a = {},
                            _a[keyName] = key,
                            _a[valName] = item,
                            _a)
                    ]);
                });
            }
            else {
                // 如果白名单存在并且 key不在白名单里面的话return
                resultArr = __spreadArray(__spreadArray([], __read(resultArr)), [
                    (_e = {},
                        _e[keyName] = key,
                        _e[valName] = targetObj[key],
                        _e)
                ]);
            }
        };
        for (var key in targetObj) {
            _loop_1(key);
        }
    }
    return resultArr;
};
/**
 * 将数组对象格式数组转换成obj，[{name: 'k1', value: 'v1'},{name: 'k2', value: 'v2'}] --> {k1: v1, k2: v2}
 * @param arrData 源数据，对象数组格式
 * @param param1 {
 *  kayName -- 默认是name，会遍历源数据中的对象内key为name的值
 *  valName -- 默认是value，会便利源数据中对象内key为value的值
 * }
 * @returns 返回一个对象
 */
export var resolveArrToObj = function (arrData, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.keyName, keyName = _c === void 0 ? 'name' : _c, _d = _b.valName, valName = _d === void 0 ? 'value' : _d;
    var obj = {};
    if (Array.isArray(arrData) && arrData.length > 0) {
        arrData.forEach(function (item) {
            var _a;
            if (item[keyName]) {
                obj = __assign(__assign({}, obj), (_a = {}, _a[item[keyName]] = item[valName] || '', _a));
            }
        });
    }
    return obj;
};
/**
 * 将指定的对象数组格式的数据转换成url拼接字符串的形式
 * @param params 对象数组格式
 * @param needEncode 是否需要encode
 * @param param2 默认匹配的对象的key名 可默认的对象的val对应的名称
 * @returns
 */
export var arrToSearchStr = function (params, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.keyName, keyName = _c === void 0 ? 'name' : _c, _d = _b.valName, valName = _d === void 0 ? 'value' : _d, _e = _b.needEncode, needEncode = _e === void 0 ? true : _e;
    if (Object.prototype.toString.call(params) === '[object Array]' && params.length > 0) {
        var searchStr_1 = '?';
        params.forEach(function (item, idx) {
            if (idx !== 0) {
                searchStr_1 += '&';
            }
            if (needEncode) {
                searchStr_1 += item[keyName] + "=" + encodeURIComponent(decodeURIComponent(item[valName]));
            }
            else {
                searchStr_1 += item[keyName] + "=" + item[valName];
            }
        });
        return searchStr_1;
    }
    else {
        return '';
    }
};
